import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const logo = require("./../assets/img/logo.svg").default;
const passwordIcon = require("./../assets/img/password-icon.svg").default;

const Dashboard = (props) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    agreedToTerms: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loginStatus, setLoginStatus] = useState("");
  const [userData, setUserData] = useState(null);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const form = new FormData();
    form.append("email", formData.email);
    form.append("password", formData.password);

    try {
      const response = await fetch(
        "https://cliqestimatebuilder.com/waiver_admin/users/login",
        {
          method: "POST",
          body: form,
        }
      );
      const responseData = await response.json();
      if (responseData.res === "1") {
        // Authentication successful, you can redirect the user or perform further actions
        if (Number(responseData.data.status) === 1) {
          console.log("Login successful.");
          setLoginStatus(responseData.msg);

          localStorage.setItem("userData", JSON.stringify(responseData.data));

          navigate("/upload-file");
        } else {
          setLoginStatus("Login failed. Your account is deactivated.");
        }
      } else {
        // Authentication failed, display an error message
        console.log("Login failed");
        setLoginStatus(responseData.msg);
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  return (
    <div className="main">
      <div className="dashDiv">
        <div className="logo">
          <img src={logo} alt="image" />
        </div>
        <h2>Welcome to Dashboard!</h2>
        <form onSubmit={handleSubmit}>
          <ul>
            <li>
              <label>Email:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </li>
            <li>
              <label>Password:</label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
              <div className="visibleClick" onClick={togglePasswordVisibility}>
                <img src={passwordIcon} alt="Toggle Password Visibility" />
              </div>
            </li>

            <li>
              <button type="submit">Login</button>
            </li>
            <span className="lgnStatus">{loginStatus}</span>
          </ul>
        </form>

        {userData && (
          <div className="home">
            <h2>Welcome, {userData.name}!</h2>
            <p>Email: {userData.email}</p>
            <p>Role: {userData.role}</p>
            {/* Add more fields as needed */}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
